
import { supabase } from '@/integrations/supabase/client';
import { SchoolInfo } from '@/types/pdf';

export const fetchSchoolInfo = async (): Promise<SchoolInfo> => {
  const defaultSchoolInfo: SchoolInfo = {
    country: 'المملكة العربية السعودية',
    ministry: 'وزارة التعليم',
    education_department: 'إدارة التعليم بالمنطقة',
    educational_supervision: 'الإشراف التربوي',
    school_name: 'المدرسة النموذجية'
  };

  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      return defaultSchoolInfo;
    }


    // محاولة جلب إعدادات المدرسة أولاً
    const { data: settings, error } = await supabase
      .from('school_settings')
      .select('school_name, country, ministry, education_department, educational_supervision, basic_info_fields')
      .eq('school_id', user.id)
      .maybeSingle();
    
    if (error) {
      console.warn('خطأ في جلب إعدادات المدرسة:', error);
    }

    if (settings && settings.school_name) {
      console.log('تم جلب إعدادات المدرسة بنجاح:', settings);
      
      // استخراج البيانات من basic_info_fields إذا كانت متوفرة
      let educationDepartment = settings.education_department || defaultSchoolInfo.education_department;
      let country = settings.country || defaultSchoolInfo.country;
      let ministry = settings.ministry || defaultSchoolInfo.ministry;
      
      if (settings.basic_info_fields) {
        try {
          let fields: any[];
          if (Array.isArray(settings.basic_info_fields)) {
            fields = settings.basic_info_fields;
          } else if (typeof settings.basic_info_fields === 'string') {
            fields = JSON.parse(settings.basic_info_fields);
          } else {
            fields = [];
          }
          
          const countryField = fields.find((field: any) => field.id === 'country');
          const ministryField = fields.find((field: any) => field.id === 'ministry');
          const educationDeptField = fields.find((field: any) => field.id === 'education_department');
          
          if (countryField?.value && typeof countryField.value === 'string') {
            country = countryField.value;
          }
          if (ministryField?.value && typeof ministryField.value === 'string') {
            ministry = ministryField.value;
          }
          if (educationDeptField?.value && typeof educationDeptField.value === 'string') {
            educationDepartment = educationDeptField.value;
          }
        } catch (e) {
          console.warn('خطأ في معالجة basic_info_fields:', e);
        }
      }
      
      return {
        country,
        ministry,
        education_department: educationDepartment,
        educational_supervision: settings.educational_supervision || defaultSchoolInfo.educational_supervision,
        school_name: settings.school_name
      };
    }

    return defaultSchoolInfo;
    
  } catch (error) {
    console.warn('تعذر تحميل إعدادات المدرسة، سيتم استخدام البيانات الافتراضية:', error);
    return defaultSchoolInfo;
  }
};
